import { useCallback } from 'react';

import { NfzMfaModal } from '~libs.desktop.shared.account';

import { useLogInToEwus } from './EwusLoginModal.actions';

type EwusLoginModalProps = {
   readonly onClose: VoidFunction;
   readonly onLogin?: () => Promise<unknown> | void;
};

export const EwusLoginModal = (props: EwusLoginModalProps): JSX.Element => {
   const { onLogin, onClose } = props;

   const handleLoginSuccess = useCallback(async () => {
      await onLogin?.();
      onClose();
   }, [onLogin, onClose]);

   const logInToEwus = useLogInToEwus({ onSuccess: handleLoginSuccess });

   return <NfzMfaModal onClose={onClose} onLogin={logInToEwus} />;
};
